import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ConfirmDialogProps {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Bottom sheet on phones, centered card on larger screens. Portaled to <body>: panels use
 * backdrop-filter, which would otherwise turn `position: fixed` into panel-relative positioning.
 */
export function ConfirmDialog({ title, children, confirmLabel, busy, danger, onConfirm, onCancel }: ConfirmDialogProps) {
  const accent = danger ? '#f87171' : '#00e5ff';
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60" onClick={onCancel}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="sci-fi-panel w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-4 max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="text-base font-semibold text-slate-100">{title}</h2>
        <div className="text-sm text-slate-300 space-y-2">{children}</div>
        <div className="flex gap-2 pt-1">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 rounded-lg border border-slate-600 text-slate-300 text-sm"
            style={{ minHeight: 44 }}
          >
            Mégse
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="flex-1 rounded-lg text-sm font-semibold disabled:opacity-50"
            style={{ minHeight: 44, background: `${accent}22`, color: accent, border: `1px solid ${accent}66` }}
          >
            {busy ? 'Folyamatban…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
